export default __webpack_public_path__ + "static/media/logo.846390ae.png";